<template>
  <div id="packages-edit">

    <IForm :label-width="100" ref="formInline" :model="edit" :elem="editElem" :rules="editRule"
           @on-submit="toSubmit" :submit="false" :showMessage="true">
      <div slot="extend">
        <Row>
          <Col span="12">
            <FormItem label="套餐名称" prop="name">
              <Input v-model="edit.name" type="text" placeholder="请输入套餐名称" maxlength="50"/>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="业务类型" prop="businessTypeId">
              <Select v-model="edit.businessTypeId" @on-change="changeBusinessType" style="width: 100%;">
                <Option v-for="item in businessTypes" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row v-show="(edit&&edit.businessTypeId===7)||applicableAge">
          <Col span="12">
            <FormItem label="适用起始年龄" prop="startApplicableAgeId">
              <Select v-model="edit.startApplicableAgeId" style="width: 100%;">
                <Option v-for="item in applicableAgeList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12" :label-width="140" >
            <FormItem label="适用结束年龄" prop="endApplicableAgeId">
              <Select v-model="edit.endApplicableAgeId" style="width: 100%;">
                <Option v-for="item in applicableAgeList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="报告模板" prop="reportTemplateIds">
              <Select v-model="edit.reportTemplateIds" multiple style="width: 100%;">
                <Option v-for="item in reportTemplates" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="状态" prop="status">
              <Select v-model="edit.status" style="width: 100%;">
                <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="备注" prop="remark">
              <Input v-model="edit.remark" type="textarea" placeholder="请输入备注" :rows="3"/>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="体检配置">
              <EditTabPanel ref="editTabPanel" :show-tabs="['physicalProject', 'lisProject']"
                            :projectIds.sync="edit.projectIds"  :lisProjectIds.sync="edit.lisProjectIds"/>
            </FormItem>
          </Col>
        </Row>
      </div>
    </IForm>

  </div>
</template>
<script>

import {_get, _save} from "@/services/screeningConfig/phlysicalPackage.js";
import {enums} from "@/services/enums";
export default {
  name: "PhysicalPackagesEdit",
  props:{
    businessTypes: {
      type: Array,
      default() {
        return [];
      }
    },
    reportTemplates: {
      type: Array,
      default() {
        return [];
      }
    },
    applicableAgeList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      edit: {
        name: "",
        code: "",
        businessTypeId: "",
        businessTypeIds: "",
        reportTemplateId: "",
        startApplicableAgeId: "",
        endApplicableAgeId: "",
        remark: "",
        status: 1,
        projectIds: [],
        lisProjectIds: [],
      },
      applicableAge:false,
      enums: enums,
      init: "",
      editElem: [],
      editRule: {
        name: [
          {required: true, message: '套餐名称不能为空', trigger: 'blur'},
          {maxlength: 50, message: "套餐名称长度不能超过50", trigger: 'blur'}
        ],
        businessTypeId: [
          {
            required: true,
            message: "请选择业务类型",
            trigger: "change",
            type: 'number'
          }
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
            type: 'number'
          }
        ],
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    changeBusinessType(val){
      if(val && val == 7){
        this.applicableAge = true;
      }else{
        this.applicableAge = false;
      }
    },
    handleModal(row) {
      this.$refs["formInline"].handleReset();
      if (!row) {
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
    },
    handleEdit(row) {
      _get({id: row.id}).then(res => {
        this.edit = Object.assign({}, res.data);
        if(this.edit.reportTemplateId){
          this.edit.reportTemplateIds = this.edit.reportTemplateId.toString().split(",");
        }
        this.$forceUpdate();
      })
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      if(this.edit.reportTemplateIds){
        this.edit.reportTemplateId = this.edit.reportTemplateIds.toString();
      }
      delete this.edit.reportTemplateIds;
      _save(this.edit).then(res => {
        if (res.errcode === 1) {
          this.$message.success("保存成功");
          this.$emit("on-submit", false);
        }else{
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    }
  }
};
</script>
<style lang="postcss" scoped>

</style>
